import { ALL_TIMEZONES, IClient, MOMENT_TIMEZONES } from "fieldpro-tools";

export const clientTimeZoneToMomentTimeZone = (client: IClient | undefined) => {
  const clientTimeZone = client?.timezone;

  if (client?.is_calendar_type_day_only) return MOMENT_TIMEZONES.UTC;

  if (!clientTimeZone) return MOMENT_TIMEZONES.UTC;
  const timezone = ALL_TIMEZONES.find((tz) => tz.abbr === clientTimeZone);
  return timezone?.utc.at(0) || MOMENT_TIMEZONES.UTC;
};
